import { atom } from 'jotai';

/**
 * Jotai atom to store the accept quote popup open state.
 * This allows sharing the popup state across different components
 * without prop drilling.
 */
export const acceptQuotePopupOpenAtom = atom<boolean>(false);

/**
 * Jotai atom to store the proposal URL segment for quote acceptance.
 * This allows sharing the URL segment across different components
 * without prop drilling.
 */
export const acceptQuotePopupUrlSegmentAtom = atom<string>('');

/**
 * Jotai atom to store the customer name for default value in accept quote popup.
 * This allows sharing the customer name across different components
 * without prop drilling.
 */
export const acceptQuotePopupCustomerNameAtom = atom<string>('');

/**
 * Jotai atom to store the customer email for default value in accept quote popup.
 * This allows sharing the customer email across different components
 * without prop drilling.
 */
export const acceptQuotePopupCustomerEmailAtom = atom<string>('');

/**
 * Jotai atom to store the current signature data.
 * This allows sharing the signature state across different components
 * without prop drilling.
 */
export const signatureDataAtom = atom<{
    hasSignature: boolean;
    dataUrl: string;
    pixelCount: number;
}>({
    hasSignature: false,
    dataUrl: '',
    pixelCount: 0,
});

/**
 * Jotai atom to store the signature mode (drawn vs typed).
 * This allows sharing the signature mode state across different components
 * without prop drilling.
 */
export const signatureModeAtom = atom<boolean>(false); // true = drawn, false = typed

/**
 * Jotai atom to store the selected font family for typed signatures.
 * This allows sharing the font family state across different components
 * without prop drilling.
 */
export const signatureFontFamilyAtom = atom<string>("'Allura', cursive");
